import { CachedBlock } from '@/classes/cachedBlock';
import { MONTH_DAY_YEAR_FORMAT } from '@/config/variables';

export const formatBlock = (
  blockId: number | null | undefined,
  timezoneName: string,
  format = MONTH_DAY_YEAR_FORMAT,
): string => {
  if (!blockId) return '';
  return CachedBlock.fromBlockId(blockId, timezoneName).format(format);
};
